module.exports = __webpack_public_path__ + "static/img/ais_03.097c2ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ais_03.png
// module id = 54Y8
// module chunks = 0